import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import Vue from 'vue';

Vue.filter('date', (value, dateFormat = 'MM/dd/yyyy HH:mm') => {
  if (!value) return '';
  return format(parseISO(value), dateFormat);
});
